module.exports = "/_next/static/images/d2ff255da23a98e68b96d8554e391139-lock.svg";